import { z } from "zod";

export const MAX_BULK_MARK_FOR_DELETION_TRANSACTION_IDS = 200;

export const bulkMarkForDeletionBodySchema = z.object({
    transactionIds: z
        .array(z.coerce.number())
        .min(1)
        .max(MAX_BULK_MARK_FOR_DELETION_TRANSACTION_IDS),
});

export enum BulkMarkForDeletionFailureReason {
    NOT_FOUND_OR_NO_ACCESS = "NOT_FOUND_OR_NO_ACCESS",
    BANK_SYNCED_NOT_DELETABLE = "BANK_SYNCED_NOT_DELETABLE",
    RECONCILED = "RECONCILED",
    HAS_LIVE_SCHEDULE = "HAS_LIVE_SCHEDULE",
    DATE_LOCKED = "DATE_LOCKED",
}

export const BULK_MARK_FOR_DELETION_FAILURE_MESSAGES: Record<
    BulkMarkForDeletionFailureReason,
    string
> = {
    [BulkMarkForDeletionFailureReason.NOT_FOUND_OR_NO_ACCESS]:
        "Transaction not found or not accessible",
    [BulkMarkForDeletionFailureReason.BANK_SYNCED_NOT_DELETABLE]:
        "Transactions synced from a bank or integration can't be deleted. Remove them through a reconciliation REMOVE, or contact engineering",
    [BulkMarkForDeletionFailureReason.RECONCILED]:
        "Transaction is reconciled with a bank statement and can't be deleted",
    [BulkMarkForDeletionFailureReason.HAS_LIVE_SCHEDULE]:
        "Remove the schedule before deleting this transaction",
    [BulkMarkForDeletionFailureReason.DATE_LOCKED]:
        "Transaction date is locked",
};

export const bulkMarkForDeletionRequestSchema =
    bulkMarkForDeletionBodySchema.extend({
        dryRun: z.boolean().optional(),
    });

export const bulkMarkForDeletionResponseSchema = z.object({
    results: z.array(
        z.object({
            transactionId: z.number(),
            success: z.boolean(),
            reason: z.nativeEnum(BulkMarkForDeletionFailureReason).optional(),
        }),
    ),
});
